import { RestService } from '../restService';
import { EmailTemplate } from '../../models';

export class EmailTemplateService extends RestService<EmailTemplate> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }

    // Backend route: GET /templateId/:id
    public async get(id: string): Promise<EmailTemplate> {
        const client = await this.axiosFactory();
        const response = await client.request<EmailTemplate>({
            method: 'GET',
            url: `/templateId/${id}`,
        });

        return response?.data as EmailTemplate;
    }

    // Backend route: GET /all/:creator
    public async getByCreator(creatorEmail: string): Promise<EmailTemplate[]> {
        if (!creatorEmail) return [];
        const client = await this.axiosFactory();
        const response = await client.request<EmailTemplate[]>({
            method: 'GET',
            url: `/all/${creatorEmail}`,
        });

        return response?.data || [];
    }
}
